export type Password_Strength_Level = 0 | 1 | 2 | 3 | 4;

export type Password_Strength_Result = {
  Level: Password_Strength_Level;
  Label: string;
  Percent: number;
};

export function Password_Strength_Score(Password: string): Password_Strength_Result {
  if (!Password) {
    return { Level: 0, Label: "", Percent: 0 };
  }

  let Points = 0;

  if (Password.length >= 8) {
    Points += 1;
  }
  if (Password.length >= 12) {
    Points += 1;
  }
  if (/[a-z]/.test(Password) && /[A-Z]/.test(Password)) {
    Points += 1;
  }
  if (/\d/.test(Password)) {
    Points += 1;
  }
  if (/[^a-zA-Z0-9]/.test(Password)) {
    Points += 1;
  }

  if (Points <= 1) {
    return { Level: 1, Label: "Weak", Percent: 25 };
  }
  if (Points === 2) {
    return { Level: 2, Label: "Fair", Percent: 50 };
  }
  if (Points === 3 || Points === 4) {
    return { Level: 3, Label: "Good", Percent: 75 };
  }

  return { Level: 4, Label: "Strong", Percent: 100 };
}

export const Password_Strength_Bar_Colors: Record<Password_Strength_Level, string> = {
  0: "bg-pq-bg-elevated/10",
  1: "bg-red-400",
  2: "bg-amber-400",
  3: "bg-cyan-400",
  4: "bg-emerald-400",
};
